
 <template lang=""> 
 <UserLayout  pageTitle="Gestione risorse">
      <template #page-content="props">
                     <v-card>
                  <v-container class="pa-8">
 
                  <v-tabs vertical>
                    <v-tab>
                      <v-icon left>
                        mdi-account-group
                      </v-icon>
                      Workers
                    </v-tab>
                      <v-tab>
                      <v-icon left>
                        mdi-car-estate
                      </v-icon>
                      Vehicles
                    </v-tab>
                    <v-tab>
                      <v-icon left>
                      mdi-cog
                      </v-icon>
                      Instruments
                    </v-tab>
                

                    <v-tab-item>
                      <v-card flat>
                        <v-card-text>
                        <FrmManageWorkers></FrmManageWorkers>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card flat>
                        <v-card-text>
                          <FrmManageVehicles></FrmManageVehicles>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card flat>
                        <v-card-text>
                        <FrmManageEquipments></FrmManageEquipments>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  
                  </v-tabs>

                  <!-- <v-divider></v-divider>
                              <template>
                      <v-btn color="error" class="mt-2" :to="{ name: 'dashboard' }">
                        Indietro
                      </v-btn>
                    </template> -->
                    </v-container>
                </v-card>

     </template>
 </UserLayout> 

 </template>
 <script>
import UserLayout from "../layout/UserLayout";
import FrmManageWorkers from "../components/Management/FrmManageWorkers";
import FrmManageEquipments from "../components/Management/FrmManageEquipments";
import FrmManageVehicles from "../components/Management/FrmManageVehicles";
import SessionHelper from "../utils/SessionHelper";
export default {
  mounted(){
    
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
  },
  components: {
    FrmManageWorkers,
    FrmManageEquipments,
    FrmManageVehicles,
    UserLayout,
  },
};
</script>
 <style lang="">
</style> 